import React, { Component } from 'react';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import withMarketPreOpen from '../../../common/market-pre-open/withMarketPreOpen';
import SearchBoxWithData from '../../../common/search-box-with-data/SearchBoxWithData';
import Chart from './Chart';
import TimeRange from './TimeRange';
import {
  changeCode,
  fetchLiquidity,
  fetchPriceInfo,
  REDUCER_NAME,
  subscribeRealtimeData,
} from './reducer';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import { connect } from 'react-redux';
import { compose } from 'redux';
import './liquidity.scss';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

class Liquidity extends AutoReloadOnFocusBlurComponent {
  constructor(props) {
    super(props);
    this.state = {
      priceData: {},
    };
  }

  reload() {
    this.fetchData();
    this.subscribeRealtime();
  }

  componentDidMount() {
    super.componentDidMount();
    this.fetchData();
    this.subscribeRealtime();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentSearch } = this.props;
    if (currentSearch.code !== prevProps.currentSearch.code) {
      this.fetchData();
      this.unSubscribeRealtime(prevProps.currentSearch);
      this.subscribeRealtime();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    const { currentSearch } = this.props;
    this.unSubscribeRealtime(currentSearch);
  }

  subscribeRealtime = () => {
    const { currentSearch } = this.props;
    if (currentSearch.isTicker) {
      MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    } else {
      MessageHub.subscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    }
  };

  unSubscribeRealtime = currentSearch => {
    if (currentSearch.isTicker) {
      MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    } else {
      MessageHub.unsubscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    }
  };

  onReceiveTicker = tickers => {
    const { currentSearch, subscribeRealtimeData } = this.props;
    const ticker = tickers.find(item => item.organCode === currentSearch.code);
    if (ticker) {
      subscribeRealtimeData(ticker);
    }
  };

  onReceiveIndex = indexs => {
    const { currentSearch, subscribeRealtimeData } = this.props;
    const index = indexs.find(item => item.comGroupCode === currentSearch.code);
    if (index) {
      subscribeRealtimeData(index);
    }
  };

  fetchData = () => {
    const { fetchLiquidity, fetchPriceInfo } = this.props;
    fetchLiquidity();
    fetchPriceInfo();
  };

  onPriceChange = priceInfo => {
    this.setState({
      priceData: priceInfo,
    });
  };

  render() {
    const { priceData } = this.state;
    const { currentSearch, changeCode } = this.props;
    return (
      <div className="tab-pane active liquidity d-flex flex-column flex-fill">
        <div className="w-100 d-flex px-20 mb-10 justify-content-between">
          <div className="align-items-center d-flex">
            <SearchBoxWithData
              onPriceChange={this.onPriceChange}
              defaultCurrentSearch={currentSearch}
              onChangeCode={changeCode}
            />
          </div>
          <TimeRange />
        </div>
        <div className="px-20">
          <Chart priceData={priceData} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentSearch: state[REDUCER_NAME].currentSearch,
  timeRange: state[REDUCER_NAME].timeRange,
});

const mapDispatchToProps = {
  subscribeRealtimeData,
  fetchLiquidity,
  fetchPriceInfo,
  changeCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  //withMarketPreOpen('flex-fill'), -- hidden preopen market clock
)(Liquidity);
